// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function StudentBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m28.474 6.577-12-4a1.481 1.481 0 0 0-.948 0l-12 4A1.5 1.5 0 0 0 2.5 8v10a1.5 1.5 0 0 0 3 0v-7.919l2.964.988a8.49 8.49 0 0 0 2.302 10.625A12.545 12.545 0 0 0 5.75 26.18a1.5 1.5 0 1 0 2.513 1.639C10.046 25.074 12.875 23.5 16 23.5s5.954 1.574 7.744 4.319a1.501 1.501 0 1 0 2.512-1.639 12.545 12.545 0 0 0-5.022-4.49 8.49 8.49 0 0 0 2.302-10.625l4.938-1.646a1.5 1.5 0 0 0 0-2.845v.003ZM16 5.577 23.256 8 16 10.419 8.75 8 16 5.577ZM21.5 15a5.5 5.5 0 1 1-10.133-2.964l4.16 1.386c.307.104.64.104.947 0l4.159-1.386A5.48 5.48 0 0 1 21.5 15Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
